<script lang="ts">
    import { login, carts, location } from "../../../store"
    import { getCarts } from "../../../api"
    import { _ } from "svelte-i18n"
    import Icon from "../../widgets/Icon.svelte"
    import { mdiCart } from "@mdi/js"
    import { navigateTo } from "../../../helper"

    const load = async () => {
        await getCarts({
            "ident.dealerNumber": $login?.account?.ident.dealerNumber,
            "ident.personNumber": $login?.account?.ident.personNumber,
        })
    }

    // always load carts if login changed
    $: if ($login) {
        load()
    }
</script>

{#if $login?.account.roles?.includes("A") || $login.account.permissions?.includes("B")}
    <button
        class="btn btn-outline btn-label-sm carts-btn"
        class:active="{$location.path?.match(/^\/[^\/]+\/carts/)}"
        on:click="{() => {
            if ($location.path?.match(/^\/[^\/]+\/carts/)) {
                history.back()
            } else {
                navigateTo('/de/carts')
            }
        }}"
    >
        <Icon path="{mdiCart}" size="24px" />
        <span class="text">{$_("cart.carts").toUpperCase()} ({$carts?.length ?? 0})</span>
    </button>
{/if}
